// src/pages/user/Links.js
import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import LinkList from "../../components/LinkList";
import LinkIcon from '@mui/icons-material/Link';

export default function Links() {
  return (
    <Paper sx={{ p: 4, borderRadius: 4 }}>
      <Box display="flex" alignItems="center" mb={2} gap={1}>
        <LinkIcon color="primary" />
        <Typography variant="h5" fontWeight={700}>
          Tất cả liên kết
        </Typography>
      </Box>
      <Typography color="text.secondary" mb={2}>
        Quản lý tất cả các liên kết rút gọn của bạn tại đây.
      </Typography>
      <LinkList token={localStorage.getItem('token')} />
    </Paper>
  );
}
